export default {
  login: {
    pageTitle: 'Login',
    title: `Hi. Let's log you in!`,
    emailLoginTitle: 'Log in with email',
    subtitle: 'Sign in with',
    helperText:
      "Don't have an account? Reach out to your Compass Manager or CDL to create an account.",
    orHelperText: 'or',
    buttons: {
      ssoLogin: 'Use your Compass ID',
      userLogin: 'Log in with email',
      userLoginBack: 'Go back',
    },
    needHelp: 'Need help logging in?',
    info: {
      warnInfo: 'Some features are not available with email log in',
      ssoError: `We couldn't log you in using your SSO account. Please try again or contact support if the issue persists.`,
      line1: 'No account?',
      line2: 'Reach out to your Digital Strategy Manager',
    },
    infoPassword: {
      subtitle: 'Enter your email and password',
      line1: 'Forgot your password?',
      line2: 'Reach out to your Digital Strategy Manager',
      authenticating: 'Please wait. Logging in...',
    },
    form: {
      fields: {
        email: 'Email',
        password: 'Password',
      },
      buttons: {
        p2Login: 'Log in',
      },
      errors: {
        credentialsNotMatched: "Your username or credentials don't seem to match",
        unexpectedError: 'Something unexpected has occurred. Please contact support.',
      },
    },
    permissionDenied: "You don't have permissions to log in",
  },
  passwordReset: {
    pageTitle: 'Reset Password',
    forgotPasswordTitle: 'Forgot password?',
    resetPasswordTitle: 'Reset Password',
    orHelperText: 'Or',
    requirement: 'Requirement',
    buttons: {
      userLogin: 'Use your Compass ID to log in',
      goBackChangeEmail: 'Go back to change an email address',
      sendResetLink: 'Send password link',
      resendResetLink: 'Resend password link',
      resetPassword: 'Reset password',
    },
    info: {
      skipPasswordResetNextTime: 'Want to skip password reset next time?',
      emailResetInstructions: `We'll email you instructions to reset it`,
      sentInstructionsTo: `We sent instructions to`,
      waitForArrivalCheckSpam: `Please give it 2 minutes to arrive. If it doesn't, be sure to check your spam folder.`,
      sendingEmail: 'Sending reset email...',
      checkYourEmail: 'Check your email',
    },
    form: {
      fields: {
        email: 'Email',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
      },
      placeholder: {
        newPassword: 'Enter your new password',
        confirmNewPassword: 'Re-enter your new password',
      },
      validation: {
        minimumCharacters: 'Minimum 15 characters',
        oneUpperCase: 'At least one uppercase character',
        oneLowerCase: 'At least one lowercase character',
        numberOrSpecialCharacter: 'A number or special character',
        passwordsMatch: 'Passwords match',
        passwordsNotMatch: `Passwords don't match`,
      },
      success: {
        emailSent: 'Password reset email has been sent successfully!',
        passwordReset: 'Your password has been reset',
      },
      errors: {
        unexpectedError: 'Something unexpected has occurred. Please contact support.',
      },
    },
  },
};
